import { SVGELEMENT } from '../../../../enums/SVGELEMENT.js';
import EL from '../../../EL/EL.js';
import SVGPATH, { svgPath, svgPathAttr, svgPathData } from '../../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGPATH.js';
// import SVGGROUP, { svgGroup, svgGroupAttr, svgGroupData, SVGGroupElementModel } from '@model/EL/svg/SVGOBJECT/SVGGROUP.js';
import SVGSHAPE from '../../../DOM/svg/SVGOBJECT/SVGSHAPE.js';
import SVGDEFS, { svgDefs, svgDefsAttr, svgDefsData } from '../../../DOM/svg/SVGOBJECT/SVGDEFS.js';
import { svgPolyline, svgPolylineAttr, svgPolylineData } from '../../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGPOLYLINE.js';
import { svgImage, svgImageAttr, svgImageData } from '../../../DOM/svg/SVGOBJECT/SVGSHAPE/SVGIMAGE.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { makeStruct } from '../../../../enums/MODELS.js';
;
;
;
// Model Structure
export const svgGroupAttr = makeAttrStruct([
    ['name'],
]);
export const svgGroupData = makeDataStruct([
    ['children', []]
]);
export const svgGroupModel = makeStruct([
    ['attributes', svgGroupAttr],
    ['data', svgGroupData]
]);
// Simplified Model
export function svgGroup(attributes, data) {
    return {
        element: SVGELEMENT.G,
        attributes: attributes || svgGroupAttr(),
        data: data || svgGroupData()
    };
}
/** Creates a Shape/Path for an SVG */
export default class SVGGROUP extends EL {
    constructor(node, model) {
        super(node, SVGELEMENT.G, model);
        this.buildSVG(model);
    }
    buildSVG(model) {
        if (!model || !model.data || !Array.isArray(model.data.children)) {
            console.warn('SVG.buildSVG: Invalid model or missing data.children', model);
            return;
        }
        model.data.children.forEach((el) => {
            switch (el.element) {
                case SVGELEMENT.G: {
                    const e = el;
                    this.addGroup(e);
                    // 	svgGroup(
                    // 		svgGroupAttr(e.attributes.name),
                    // 		svgGroupData(e.data.children)
                    // 	)
                    // );
                    break;
                }
                case SVGELEMENT.DEFS: {
                    const e = el;
                    this.addDefs(svgDefs(svgDefsAttr(), svgDefsData(e.data.children)));
                    break;
                }
                case SVGELEMENT.PATH: {
                    const e = el;
                    this.addPath(svgPath(svgPathAttr(e.attributes.d, e.attributes.fill, e.attributes.stroke, e.attributes.style, e.attributes.name), svgPathData()));
                    break;
                }
                case SVGELEMENT.LINE: {
                    this.addShape(SVGELEMENT.LINE, el);
                    break;
                }
                case SVGELEMENT.RECT: {
                    this.addShape(SVGELEMENT.RECT, el);
                    break;
                }
                case SVGELEMENT.CIRCLE: {
                    this.addShape(SVGELEMENT.CIRCLE, el);
                    break;
                }
                case SVGELEMENT.ELLIPSE: {
                    this.addShape(SVGELEMENT.ELLIPSE, el);
                    break;
                }
                case SVGELEMENT.POLYGON: {
                    this.addShape(SVGELEMENT.POLYGON, el);
                    break;
                }
                case SVGELEMENT.POLYLINE: {
                    const e = el;
                    this.addShape(SVGELEMENT.POLYLINE, svgPolyline(svgPolylineAttr(e.attributes.points, e.attributes.fill, e.attributes.stroke, e.attributes.style), svgPolylineData()));
                    break;
                }
                case SVGELEMENT.IMAGE: {
                    const e = el;
                    this.addShape(SVGELEMENT.IMAGE, svgImage(svgImageAttr(e.attributes.href, e.attributes.width, e.attributes.height, e.attributes.style), svgImageData()));
                    break;
                }
                case SVGELEMENT.TEXT: {
                    this.addText(SVGELEMENT.TEXT, el);
                    break;
                }
                // case SVGELEMENT.TSPAN: {
                // 	console.log('SVGTSPAN', el);
                // 	this.addTSpan(SVGELEMENT.TSPAN, el as SVGTSpanElementModel);
                // 	break;
                // }
                default:
                    console.warn('SVG.setPaths: Undefined child element', el);
            }
        });
    }
    createElement() {
        const el = document.createElementNS('http://www.w3.org/2000/svg', SVGELEMENT.G);
        return el;
    }
    /** Adds a group to this SVG Element */
    addGroup(model) {
        return this.addChild(new SVGGROUP(this, model));
    }
    /** Adds a path to this SVG Element */
    addPath(model) {
        return this.addChild(new SVGPATH(this, model));
    }
    /** Adds a shape to this SVG Element */
    addShape(type, model) {
        return this.addChild(new SVGSHAPE(this, type, model));
    }
    /** Adds a defs element to this SVG Element */
    addDefs(model) {
        return this.addChild(new SVGDEFS(this, model));
    }
}
